import { getTokens } from 'core/classes/helpers/StorageHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'
import { IGeneralReportsResponse } from 'partner360/models/report/generalReports/IGeneralReportsResponse'
import settings from 'src/config/settings'

export const fetchGeneralReportsSettings = async (): Promise<IGeneralReportsResponse> => {
  const serviceUrl = settings.httpsServices.partner360
    ? settings.httpsServices.partner360
    : 'https://partner360-service-itg.corp.hpicloud.net'

  const url = `${serviceUrl}/api/v0/reporting/reportsSet`

  const [accessToken] = getTokens()
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, payload: {}, headers })
    return {
      Reports: response.data.Reports,
    }
  } catch (e) {
    Logger.error(e)
    return { Reports: [] }
  }
}
